import { Api } from '../api';
import { messages } from '../endpoints';
import type { DownloadAttachmentRequest, MessageEntity, MessageItemsResponse, MessageThreadsResponse, PostMessageResponse } from './models';

export class MessagesApi extends Api {
  static getThreads = (signal?: AbortSignal): Promise<MessageThreadsResponse> => this.get<MessageThreadsResponse>(messages.getThreads(), { signal });

  static getThread = (threadId: string, signal?: AbortSignal): Promise<MessageItemsResponse> => this.get(messages.getThread(threadId), { signal });

  static sendMessage = async (request: MessageEntity, signal?: AbortSignal) => {
    const { attachments, ...data } = request;

    const result = await this.post<PostMessageResponse>(messages.postMessage(), data, { signal });

    if (attachments?.length) {
      const formData = new FormData();
      attachments.forEach((item) => formData.append('file', item));

      return this.post(messages.postAttachment(result.data.messageId), formData, { signal });
    }

    return result;
  };

  static deleteMessageGroup = (groupId: string, signal?: AbortSignal) =>
    this.delete(messages.deleteMessage(groupId), { responseType: 'none', signal });

  static markGroupRead = (groupId: string, signal?: AbortSignal) => this.put(messages.readMessage(), { groupId }, { responseType: 'none', signal });

  static downloadAttachment = async (request: DownloadAttachmentRequest, signal?: AbortSignal) =>
    await this.get<Blob>(messages.downloadAttachment(request.messageId, request.fileId), { signal });
}
